import { Tag } from '@moia-dev/pace-web'

type TagGroupProps<T> = {
  items: T[] | null | undefined
  getKey: (item: T) => string
  getLabel: (item: T) => string
}

export const TagGroup = <T,>({ items, getKey, getLabel }: TagGroupProps<T>) => {
  return (
    <div
      css={theme => ({
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.space.Space1,
        maxHeight: 24 * 12,
        overflowY: 'auto',
        scrollbarWidth: 'thin',
      })}
    >
      {items?.map(item => (
        <Tag key={getKey(item)} label={getLabel(item)} />
      ))}
    </div>
  )
}
